import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactNode, useEffect, useState } from 'react'
import { usePotentiallyAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { createQueryClient } from './createQueryClient'

interface ReactQueryProviderProps {
  children: ReactNode
}

export function ReactQueryProvider({ children }: ReactQueryProviderProps) {
  const [queryClient] = useState(() => createQueryClient())
  const { org } = usePotentiallyAuthenticatedUser()
  const organisationId = org?.organisationId

  useEffect(() => {
    // Scoped by org so a cached query result never broadcasts across a user's tabs open on
    // different organisations (query keys like requestId aren't org-scoped on the client).
    if (!organisationId) return

    const unsubscribe = broadcastQueryClient({
      queryClient,
      broadcastChannel: `${process.env.OMNEA_APP_ENV}-${organisationId}-omnea-broadcast-channel`,
    })
    return () => {
      unsubscribe()
    }
  }, [queryClient, organisationId])

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" position="bottom" />
      {children}
    </QueryClientProvider>
  )
}
